import { AppointmentService } from '$api-client/types.gen'
import { Text } from '$components'

export type ServicesHeadingProps = {
  services: AppointmentService[],
}

export function ServicesHeading({ services }: ServicesHeadingProps) {
  return (
    <div className="flex items-center gap-2">
      {/* Colour Square */}
      <div
        style={{ backgroundColor: services[0].service.colour }}
        className="size-3.5 min-w-3.5 min-h-3.5 rounded-[5px]"
      />

      {/* Name */}
      <Text
        as="h3"
        type="s"
        className="truncate"
      >
        { services[0].service_values.name }
      </Text>

      {/* Additional Services Badge */}
      { services.length > 1 && (
        <div className="bg-white text-xs py-0.5 px-1.5 rounded-md font-light text-nowrap">
          {`+ ${services.length - 1} more`}
        </div>
      )}
    </div>
  )
}
